// extracted by mini-css-extract-plugin
export default {"wrapper":"form-actions_wrapper__tY3d+","wrapper--sticky":"form-actions_wrapper--sticky__JnneE"};